export class SegmentDataValueObject {
  #brandId
  #channel
  #hitInformation
  #hitInformation2
  #hitOrigin
  #modelId
  #pageCategoryLevel1
  #pageName
  #pageType

  constructor({
    brandId,
    channel,
    hitInformation,
    hitInformation2,
    hitOrigin,
    modelId,
    pageCategoryLevel1,
    pageName,
    pageType
  }) {
    this.#brandId = brandId
    this.#channel = channel
    this.#hitInformation = hitInformation
    this.#hitInformation2 = hitInformation2
    this.#hitOrigin = hitOrigin
    this.#modelId = modelId
    this.#pageCategoryLevel1 = pageCategoryLevel1
    this.#pageName = pageName
    this.#pageType = pageType
  }

  static create({
    brandId,
    channel,
    hitInformation,
    hitInformation2,
    hitOrigin,
    modelId,
    pageCategoryLevel1,
    pageName,
    pageType
  }) {
    return new SegmentDataValueObject({
      brandId,
      channel,
      hitInformation,
      hitInformation2,
      hitOrigin,
      modelId,
      pageCategoryLevel1,
      pageName,
      pageType
    })
  }

  get value() {
    return {
      ...(this.#brandId && {brandId: this.#brandId}),
      ...(this.#channel && {channel: this.#channel}),
      ...(this.#hitInformation && {hitInformation: this.#hitInformation}),
      ...(this.#hitInformation2 && {hitInformation2: this.#hitInformation2}),
      ...(this.#hitOrigin && {hitOrigin: this.#hitOrigin}),
      ...(this.#modelId && {modelId: this.#modelId}),
      ...(this.#pageCategoryLevel1 && {pageCategoryLevel1: this.#pageCategoryLevel1}),
      ...(this.#pageName && {pageName: this.#pageName}),
      ...(this.#pageType && {pageType: this.#pageType})
    }
  }

  getValueToSnakeCase() {
    return JSON.parse(
      JSON.stringify({
        ...(this.#brandId && {brand_id: this.#brandId}),
        ...(this.#channel && {channel: this.#channel}),
        ...(this.#hitInformation && {hit_information: this.#hitInformation}),
        ...(this.#hitInformation2 && {hit_information2: this.#hitInformation2}),
        ...(this.#hitOrigin && {hit_origin: this.#hitOrigin}),
        ...(this.#modelId && {model_id: this.#modelId}),
        ...(this.#pageCategoryLevel1 && {page_category_level1: this.#pageCategoryLevel1}),
        ...(this.#pageName && {page_name: this.#pageName}),
        ...(this.#pageType && {page_type: this.#pageType})
      })
    )
  }
}
